export default function PageHeader({ title, subtitle, actions, count }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight flex items-center gap-3" data-testid="page-title">
          {title}
          {count != null && (
            <span className="text-sm font-medium text-muted-foreground bg-muted rounded-full px-2.5 py-0.5">{count}</span>
          )}
        </h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:justify-end">{actions}</div>}
    </div>
  );
}
